var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightningstrike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.482 18.307l68.088 108.87-66.244 57.555 98.518 117.485-15.184 61.19 31.707 47.357c-7.105 4.968-13.8 10.476-20.04 16.463L68.268 346.8l30.278-15.138-80.19-122.713v78.92l25.94 34.96-17.662 31.54 33.834 33.485-24.6 37.483 60.45 54.406c-1.99 4.436-3.804 8.97-5.415 13.604h317.196c-1.926-5.546-4.137-10.952-6.604-16.213l64.03-65.492-51.272-58.762 2.412-9.872 17.65-35.838 38.887 29.164 20.445-24.053v-94.176l-37.71 64.083-35.904-31.76-35.458 145.218-38.77 15.212c-9.884-6.924-20.553-12.805-31.857-17.488l74.93-104.864-23.672-39.678 48.473-72.346-93.783 7.504 45.834-79.63 33.914 31.183 69.215-117.233h-21.7l-51.866 87.843-34.108-31.36-63.893 111.005-25.52 2.043 95.906-169.53h-134.18l-53.642 245.225 85.873-22.902-28.32 49.206-53.696 15.998 7.63 85.092c-7.638 2.81-15.008 6.158-22.07 10l-27.48-41.043 15.48-62.39-6.643-7.925-59.22-102.59 85.745-45.503-47.238-123.168H36.482zm283.875 207.755l-86 155.25c-8.45.748-16.718 2.11-24.752 4.057l-5.916-65.99 46.195-13.763 41.314-71.78 29.157-7.774zm33.332 39.946l12.873 21.576-71.024 99.395c-6.507-1.84-13.18-3.295-19.99-4.347l78.14-116.625zm55.14 109.084l31.264 35.83-47.92 49.014c-8.19-13.21-18.144-25.19-29.55-35.602l37.804-14.834 8.402-34.408zM74.018 401.268l43.662 43.212c-4.532 5.75-8.697 11.805-12.46 18.13l-44.927-40.43 13.725-20.912z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningstrike);
export default __webpack_public_path__ + "static/media/lightningstrike.d3f96d75a8f4514c1627f04199f81d1f.svg";
export { ForwardRef as ReactComponent };